import React, { useState } from 'react'
import { TableSortLabel } from '@material-ui/core'

import { StyledTableHeadCell } from './style'

const TableHeadCell = ({ onRequestSort, headerData }) => {
  const [order, setOrder] = useState('desc')
  const { label } = headerData
  const handleSortRequest = () => {
    const newOrder = order === 'desc' ? 'asc' : 'desc'
    onRequestSort(label, newOrder)
    setOrder(newOrder)
  }

  return (
    <StyledTableHeadCell sortDirection={order}>
      {headerData.sortable ? (
        <TableSortLabel direction={order} onClick={handleSortRequest}>
          <div dangerouslySetInnerHTML={{ __html: label }} />
        </TableSortLabel>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: label }} />
      )}
    </StyledTableHeadCell>
  )
}

export default TableHeadCell
